import {apiInstance} from "../api";

// «Новое обращение»: the request goes straight to Bitrix as a deal
export class IntakeService {
  static fetchOptions() {
    return apiInstance.get('/intake/options');
  }

  // {phone, phone2, email, kind}: what Bitrix already has with this phone
  static check(params) {
    return apiInstance.get('/intake/check', {params});
  }

  static fetchFlat(id) {
    return apiInstance.get(`/intake/flat/${id}`);
  }

  static create(body) {
    return apiInstance.post('/intake', body);
  }

  static fetchJournal(params) {
    return apiInstance.get('/intake/journal', {params});
  }
}
